/**
 * tdesign v0.21.1
 * (c) 2022 tdesign
 * @license MIT
 */

import { c as components } from './_chunks/dep-ae211c4f.mjs';
export { Button } from './button/index.mjs';
export { Icon } from './icon/index.mjs';
export { Link } from './link/index.mjs';
export { Col, Row } from './grid/index.mjs';
export { Aside, Content, Footer, Header, Layout } from './layout/index.mjs';
export { Divider } from './divider/index.mjs';
export { Space } from './space/index.mjs';
export { Affix } from './affix/index.mjs';
export { Anchor, AnchorItem, AnchorTarget } from './anchor/index.mjs';
export { Breadcrumb, BreadcrumbItem } from './breadcrumb/index.mjs';
export { Dropdown, DropdownItem, DropdownMenu } from './dropdown/index.mjs';
export { Jumper } from './jumper/index.mjs';
export { HeadMenu, Menu, MenuGroup, MenuItem, Submenu } from './menu/index.mjs';
export { Pagination } from './pagination/index.mjs';
export { StepItem, Steps } from './steps/index.mjs';
export { TabPanel, Tabs } from './tabs/index.mjs';
export { Cascader, CascaderPanel } from './cascader/index.mjs';
export { Checkbox, CheckboxGroup } from './checkbox/index.mjs';
export { DatePicker, DatePickerPanel, DateRangePicker, DateRangePickerPanel } from './date-picker/index.mjs';
export { Form, FormItem } from './form/index.mjs';
export { InputAdornment } from './input-adornment/index.mjs';
export { Input, InputGroup } from './input/index.mjs';
export { InputNumber } from './input-number/index.mjs';
export { Radio, RadioButton, RadioGroup } from './radio/index.mjs';
export { Option, OptionGroup, Select } from './select/index.mjs';
export { Slider, SliderButton } from './slider/index.mjs';
export { Switch } from './switch/index.mjs';
export { TagInput } from './tag-input/index.mjs';
export { SelectInput } from './select-input/index.mjs';
export { Textarea } from './textarea/index.mjs';
export { Transfer } from './transfer/index.mjs';
export { TimePicker, TimePickerPanel, TimeRangePicker } from './time-picker/index.mjs';
export { TreeSelect } from './tree-select/index.mjs';
export { ColorPicker, ColorPickerPanel } from './color-picker/index.mjs';
export { RangeInput, RangeInputPopup } from './range-input/index.mjs';
export { Avatar, AvatarGroup } from './avatar/index.mjs';
export { Badge } from './badge/index.mjs';
export { Calendar } from './calendar/index.mjs';
export { Card } from './card/index.mjs';
export { Comment } from './comment/index.mjs';
export { ImageViewer } from './image-viewer/index.mjs';
export { List, ListItem, ListItemMeta } from './list/index.mjs';
export { Progress } from './progress/index.mjs';
export { Skeleton } from './skeleton/index.mjs';
export { Swiper, SwiperItem } from './swiper/index.mjs';
export { BaseTable, EnhancedTable, PrimaryTable, Table } from './table/index.mjs';
export { CheckTag, Tag } from './tag/index.mjs';
export { Tooltip } from './tooltip/index.mjs';
export { Tree } from './tree/index.mjs';
export { Collapse, CollapsePanel } from './collapse/index.mjs';
export { Watermark } from './watermark/index.mjs';
export { Rate } from './rate/index.mjs';
export { Alert } from './alert/index.mjs';
export { DialogPlugin } from './dialog/plugin.mjs';
export { Dialog } from './dialog/index.mjs';
export { Drawer } from './drawer/index.mjs';
export { Guide } from './guide/index.mjs';
export { default as LoadingPlugin } from './loading/plugin.mjs';
export { Loading } from './loading/index.mjs';
export { default as MessagePlugin } from './message/plugin.mjs';
export { Message } from './message/index.mjs';
export { default as NotifyPlugin } from './notification/plugin.mjs';
export { Notification } from './notification/index.mjs';
export { Popconfirm } from './popconfirm/index.mjs';
export { Popup } from './popup/index.mjs';
export { Upload } from './upload/index.mjs';
export { ConfigProvider } from './config-provider/index.mjs';
import './button/button.mjs';
import './_chunks/dep-8c39d78a.mjs';
import './_chunks/dep-556a2f2c.mjs';
import './_chunks/dep-0b4c3c44.mjs';
import 'vue';
import './button/props.mjs';
import './hooks/useRipple.mjs';
import './hooks/useKeepAnimation.mjs';
import './hooks/useConfig.mjs';
import './config-provider/useConfig.mjs';
import './_chunks/dep-bfb23a5e.mjs';
import './_chunks/dep-a48de419.mjs';
import './_chunks/dep-2a7dc5c7.mjs';
import './_chunks/dep-9311bf66.mjs';
import './_chunks/dep-4889eb51.mjs';
import './_chunks/dep-0b4185fe.mjs';
import './_chunks/dep-3ca5fb38.mjs';
import './_chunks/dep-7071345f.mjs';
import './_chunks/dep-d2403b2f.mjs';
import './_chunks/dep-7922050a.mjs';
import './_chunks/dep-169ea640.mjs';
import './_chunks/dep-f6b25712.mjs';
import './_chunks/dep-59545a4d.mjs';
import './_chunks/dep-c27b1c14.mjs';
import './_chunks/dep-7d96367f.mjs';
import './_chunks/dep-827c4600.mjs';
import './_chunks/dep-0820e0e2.mjs';
import './_chunks/dep-caad2e91.mjs';
import './_chunks/dep-3d4aad09.mjs';
import './_chunks/dep-8e38f523.mjs';
import './_chunks/dep-469bf54b.mjs';
import './_chunks/dep-8ef9fb8e.mjs';
import './_chunks/dep-e769aafd.mjs';
import './_chunks/dep-400798c5.mjs';
import './_chunks/dep-361522ee.mjs';
import './_common/js/global-config/default-config.mjs';
import './_common/js/global-config/locale/zh_CN.mjs';
import './config-provider/type.mjs';
import './utils/set-style.mjs';
import './form/hooks.mjs';
import './hooks/tnode.mjs';
import './_chunks/dep-40522c7c.mjs';
import './_chunks/dep-83862ee1.mjs';
import './_chunks/dep-8e451077.mjs';
import './_chunks/dep-a82b01df.mjs';
import './_chunks/dep-192e10f1.mjs';
import './_chunks/dep-977c5cdd.mjs';
import './_chunks/dep-755716aa.mjs';
import './_chunks/dep-82798823.mjs';
import './_chunks/dep-52cbb58a.mjs';
import './_chunks/dep-db11154e.mjs';
import './_chunks/dep-baa4f9dc.mjs';
import './utils/render-tnode.mjs';
import './_chunks/dep-2684fd15.mjs';
import './loading/directive.mjs';
import './loading/loading.mjs';
import './_chunks/dep-dcf624da.mjs';
import './loading/icon/gradient.mjs';
import './_common/js/loading/circle-adapter.mjs';
import './_common/js/utils/set-style.mjs';
import './_common/js/utils/helper.mjs';
import './_chunks/dep-e68fd68c.mjs';
import './utils/dom.mjs';
import './utils/easing.mjs';
import './utils/transfer-dom.mjs';
import './loading/props.mjs';
import './utils/withInstall.mjs';
import './style/css.mjs';
import './loading/type.mjs';
import './button/type.mjs';
import 'tdesign-icons-vue-next';
import './link/link.mjs';
import './link/props.mjs';
import './link/type.mjs';
import './grid/row.mjs';
import './grid/row-props.mjs';
import './grid/common.mjs';
import './utils/responsive.mjs';
import './hooks/useListener.mjs';
import './grid/col.mjs';
import './grid/col-props.mjs';
import './grid/type.mjs';
import './layout/layout.mjs';
import './layout/header.mjs';
import './layout/header-props.mjs';
import './layout/footer.mjs';
import './layout/footer-props.mjs';
import './layout/aside.mjs';
import './layout/aside-props.mjs';
import './layout/content.mjs';
import './layout/type.mjs';
import './divider/divider.mjs';
import './divider/props.mjs';
import './divider/type.mjs';
import './space/space.mjs';
import './space/props.mjs';
import './hooks/slot.mjs';
import './space/type.mjs';
import './affix/affix.mjs';
import './_chunks/dep-9262ea29.mjs';
import './affix/props.mjs';
import './affix/type.mjs';
import './anchor/anchor.mjs';
import './anchor/utils.mjs';
import './anchor/props.mjs';
import './anchor/constants.mjs';
import './anchor/anchor-item.mjs';
import './anchor/anchor-item-props.mjs';
import './anchor/anchor-target.mjs';
import './utils/clipboard.mjs';
import './anchor/anchor-target-props.mjs';
import './hooks/useGlobalIcon.mjs';
import './message/messageList.mjs';
import './message/const.mjs';
import './message/message.mjs';
import './message/props.mjs';
import './message/animation.mjs';
import './anchor/type.mjs';
import './breadcrumb/breadcrumb.mjs';
import './breadcrumb/props.mjs';
import './breadcrumb/breadcrumb-item.mjs';
import './breadcrumb/breadcrumb-item-props.mjs';
import './tooltip/tooltip.mjs';
import './tooltip/props.mjs';
import './popup/props.mjs';
import './tooltip/util.mjs';
import './hooks/useVModel.mjs';
import './popup/popup.mjs';
import '@popperjs/core';
import './popup/container.mjs';
import './popup/type.mjs';
import './tooltip/type.mjs';
import './breadcrumb/type.mjs';
import './dropdown/dropdown-item.mjs';
import './dropdown/dropdown-item-props.mjs';
import './dropdown/const.mjs';
import './dropdown/dropdown.mjs';
import './dropdown/dropdown-menu.mjs';
import './utils/helper.mjs';
import './dropdown/props.mjs';
import './dropdown/type.mjs';
import './jumper/jumper.mjs';
import './jumper/props.mjs';
import './jumper/type.mjs';
import './menu/menu.mjs';
import './menu/props.mjs';
import './menu/v-menu.mjs';
import './_chunks/dep-84a9ab7d.mjs';
import './_common/js/log/log.mjs';
import './hooks/useDefaultValue.mjs';
import './menu/head-menu.mjs';
import './menu/head-menu-props.mjs';
import './tabs/tabs.mjs';
import './tabs/tab-panel.mjs';
import './tabs/tab-panel-props.mjs';
import './hooks/useDestroyOnClose.mjs';
import './tabs/tab-nav.mjs';
import './_chunks/dep-241fdd8c.mjs';
import './_chunks/dep-050b3eb2.mjs';
import './tabs/props.mjs';
import './_common/js/tabs/base.mjs';
import './tabs/tab-nav-item.mjs';
import './tabs/tab-nav-bar.mjs';
import './hooks/useDragSort.mjs';
import './tabs/type.mjs';
import './menu/submenu.mjs';
import './menu/submenu-props.mjs';
import './common-components/fake-arrow.mjs';
import './menu/menu-item.mjs';
import './menu/menu-item-props.mjs';
import './utils/event.mjs';
import './menu/menu-group.mjs';
import './menu/menu-group-props.mjs';
import './menu/type.mjs';
import './pagination/pagination.mjs';
import './_chunks/dep-869cd310.mjs';
import './pagination/props.mjs';
import './pagination/usePaginationClasses.mjs';
import './pagination/useMoreAction.mjs';
import './input-number/input-number.mjs';
import './input-number/props.mjs';
import './input-number/useInputNumber.mjs';
import './hooks/useCommonClassName.mjs';
import './_common/js/input-number/number.mjs';
import './_common/js/input-number/large-number.mjs';
import './_common/js/log/index.mjs';
import './input/input.mjs';
import './input/props.mjs';
import './input/useInput.mjs';
import './form/const.mjs';
import './hooks/index.mjs';
import './hooks/icon.mjs';
import './hooks/useVirtualScroll.mjs';
import './input/useInputEventHandler.mjs';
import './input/useInputWidth.mjs';
import './input/input-group.mjs';
import './input/type.mjs';
import './input-number/type.mjs';
import './select/select.mjs';
import './_chunks/dep-32e8a48d.mjs';
import './_chunks/dep-0c515b62.mjs';
import './_chunks/dep-759eacca.mjs';
import './_chunks/dep-544fb8fd.mjs';
import './_chunks/dep-72359af2.mjs';
import './_chunks/dep-ad0cc3b4.mjs';
import './_chunks/dep-ef911020.mjs';
import './_chunks/dep-efb50e88.mjs';
import './_chunks/dep-10db0930.mjs';
import './_chunks/dep-6d14fb16.mjs';
import 'lodash';
import './select/select-panel.mjs';
import './_chunks/dep-f1423dd2.mjs';
import './select/option.mjs';
import './select/option-props.mjs';
import './select/helper.mjs';
import './checkbox/checkbox.mjs';
import './checkbox/props.mjs';
import './checkbox/constants.mjs';
import './checkbox/group.mjs';
import './_chunks/dep-2ca0e5ff.mjs';
import './_chunks/dep-c5bb3a66.mjs';
import './checkbox/checkbox-group-props.mjs';
import './checkbox/type.mjs';
import './select/optionGroup.mjs';
import './select/option-group-props.mjs';
import './select/props.mjs';
import './select/hooks/usePanelVirtualScroll.mjs';
import './select/hooks/useSelectOptions.mjs';
import './select-input/select-input.mjs';
import './select-input/props.mjs';
import './select-input/useSingle.mjs';
import './select-input/useMultiple.mjs';
import './tag-input/tag-input.mjs';
import './tag-input/props.mjs';
import './tag-input/hooks/useTagScroll.mjs';
import './tag-input/useTagList.mjs';
import './tag/tag.mjs';
import './tag/props.mjs';
import './tag/check-tag.mjs';
import './tag/check-tag-props.mjs';
import './tag/type.mjs';
import './tag-input/hooks/useHover.mjs';
import './tag-input/hooks/useDragSorter.mjs';
import './tag-input/type.mjs';
import './select-input/useOverlayInnerStyle.mjs';
import './select-input/type.mjs';
import './select/type.mjs';
import './input-adornment/input-adornment.mjs';
import './input-adornment/props.mjs';
import './input-adornment/type.mjs';
import './pagination/type.mjs';
import './steps/steps.mjs';
import './steps/props.mjs';
import './steps/step-item-props.mjs';
import './steps/step-item.mjs';
import './steps/type.mjs';
import './cascader/cascader.mjs';
import './cascader/components/Panel.mjs';
import './cascader/components/Item.mjs';
import './cascader/core/helper.mjs';
import './cascader/core/className.mjs';
import './cascader/props.mjs';
import './cascader/core/effect.mjs';
import './cascader/hooks.mjs';
import './_chunks/dep-b4aa9d43.mjs';
import './_common/js/tree/tree-store.mjs';
import './_chunks/dep-7ffddffa.mjs';
import './_common/js/tree/tree-node.mjs';
import './_chunks/dep-88e40e6a.mjs';
import './_common/js/tree/tree-node-model.mjs';
import './cascader/cascader-panel.mjs';
import './cascader/type.mjs';
import './date-picker/DatePicker.mjs';
import './_chunks/dep-f362c0f2.mjs';
import './date-picker/hooks/useSingle.mjs';
import './_common/js/date-picker/format.mjs';
import './_common/js/date-picker/utils.mjs';
import './_chunks/dep-faa6c58f.mjs';
import './_chunks/dep-3568c22b.mjs';
import './date-picker/hooks/useSingleValue.mjs';
import './date-picker/props.mjs';
import './date-picker/panel/SinglePanel.mjs';
import './date-picker/panel/PanelContent.mjs';
import './date-picker/base/Header.mjs';
import './date-picker/base/Table.mjs';
import './date-picker/base/Cell.mjs';
import './time-picker/panel/time-picker-panel.mjs';
import './_common/js/time-picker/const.mjs';
import './time-picker/panel/props.mjs';
import './time-picker/props.mjs';
import './time-picker/panel/single-panel.mjs';
import './_chunks/dep-a25f46ac.mjs';
import './_common/js/time-picker/utils.mjs';
import './date-picker/panel/ExtraContent.mjs';
import './date-picker/base/Footer.mjs';
import './date-picker/hooks/useTableData.mjs';
import './date-picker/hooks/useDisableDate.mjs';
import './date-picker/DatePickerPanel.mjs';
import './date-picker/date-picker-panel-props.mjs';
import './date-picker/DateRangePicker.mjs';
import './date-picker/date-range-picker-props.mjs';
import './date-picker/panel/RangePanel.mjs';
import './date-picker/hooks/useRange.mjs';
import './date-picker/hooks/useRangeValue.mjs';
import './range-input/range-input.mjs';
import './range-input/props.mjs';
import './range-input/range-input-popup.mjs';
import './range-input/range-input-popup-props.mjs';
import './range-input/type.mjs';
import './date-picker/DateRangePickerPanel.mjs';
import './date-picker/date-range-picker-panel-props.mjs';
import './date-picker/type.mjs';
import './form/form.mjs';
import './_chunks/dep-0f8953f7.mjs';
import './form/props.mjs';
import './form/form-item.mjs';
import './_chunks/dep-808dde7b.mjs';
import './form/form-model.mjs';
import './form/form-item-props.mjs';
import './form/type.mjs';
import './radio/radio.mjs';
import './radio/props.mjs';
import './radio/constants.mjs';
import './radio/group.mjs';
import './radio/radio-group-props.mjs';
import './radio/radio-button.mjs';
import './radio/type.mjs';
import './slider/slider.mjs';
import './slider/props.mjs';
import './slider/slider-button.mjs';
import './slider/hooks/useSliderTooltip.mjs';
import './slider/util/common.mjs';
import './slider/util/constants.mjs';
import './slider/hooks/useSliderMark.mjs';
import './slider/slider-mark.mjs';
import './slider/hooks/useSliderInput.mjs';
import './slider/type.mjs';
import './switch/switch.mjs';
import './switch/props.mjs';
import './switch/type.mjs';
import './textarea/textarea.mjs';
import './textarea/props.mjs';
import './textarea/calcTextareaHeight.mjs';
import './textarea/type.mjs';
import './transfer/transfer.mjs';
import './transfer/components/transfer-list.mjs';
import './transfer/utils.mjs';
import './transfer/components/transfer-search.mjs';
import './transfer/components/transfer-operations.mjs';
import './transfer/props.mjs';
import './time-picker/time-picker.mjs';
import './time-picker/time-range-picker.mjs';
import './time-picker/time-range-picker-props.mjs';
import './time-picker/type.mjs';
import './tree-select/tree-select.mjs';
import './tree-select/props.mjs';
import './tree/td-tree.mjs';
import './tree/props.mjs';
import './tree/constants.mjs';
import './tree/useTree.mjs';
import './tree/tree-item.mjs';
import './tree/util.mjs';
import './tree/hooks/useDraggable.mjs';
import './_chunks/dep-2c582e31.mjs';
import './tree/hooks/useOnDrag.mjs';
import './tree/hooks/useExposeFunc.mjs';
import './tree/type.mjs';
import './tree-select/interface.mjs';
import './tree-select/type.mjs';
import './color-picker/color-picker-panel.mjs';
import './color-picker/props.mjs';
import './color-picker/panel/index.mjs';
import './color-picker/const.mjs';
import './_common/js/color-picker/constants.mjs';
import './color-picker/panel/header.mjs';
import './color-picker/hooks.mjs';
import './color-picker/panel/linear-gradient.mjs';
import './color-picker/utils/index.mjs';
import './_common/js/color-picker/index.mjs';
import './_common/js/color-picker/cmyk.mjs';
import './_common/js/color-picker/color.mjs';
import './_chunks/dep-fda161b3.mjs';
import './_common/js/color-picker/draggable.mjs';
import './color-picker/panel/base-props.mjs';
import './color-picker/panel/saturation.mjs';
import './color-picker/panel/hue.mjs';
import './color-picker/panel/slider.mjs';
import './color-picker/panel/alpha.mjs';
import './color-picker/panel/format/index.mjs';
import './color-picker/panel/format/inputs.mjs';
import './color-picker/panel/format/config.mjs';
import './color-picker/panel/swatches.mjs';
import './color-picker/color-picker.mjs';
import './color-picker/trigger.mjs';
import './color-picker/type.mjs';
import './avatar/avatar.mjs';
import './avatar/props.mjs';
import './avatar/group.mjs';
import './avatar/avatar-group-props.mjs';
import './avatar/type.mjs';
import './badge/badge.mjs';
import './badge/props.mjs';
import './badge/type.mjs';
import './calendar/calendar.mjs';
import './calendar/props.mjs';
import './calendar/utils.mjs';
import './calendar/const.mjs';
import './calendar/hook/index.mjs';
import './calendar/hook/useState.mjs';
import './calendar/hook/useCalendarClass.mjs';
import './calendar/hook/useController.mjs';
import './calendar/hook/useColHeaders.mjs';
import './calendar/calendar-cell.mjs';
import './calendar/type.mjs';
import './card/card.mjs';
import './card/props.mjs';
import './card/type.mjs';
import './comment/comment.mjs';
import './comment/props.mjs';
import './comment/type.mjs';
import './image-viewer/image-viewer.mjs';
import './image-viewer/props.mjs';
import './image-viewer/base/ImageModalIcon.mjs';
import './image-viewer/base/ImageViewerUtils.mjs';
import './image-viewer/utils.mjs';
import './image-viewer/base/ImageItem.mjs';
import './image-viewer/hooks.mjs';
import './image-viewer/base/ImageViewerModal.mjs';
import './dialog/dialog.mjs';
import './dialog/props.mjs';
import './dialog/hooks.mjs';
import './dialog/stack.mjs';
import './dialog/type.mjs';
import './image-viewer/const.mjs';
import './image-viewer/type.mjs';
import './list/list.mjs';
import './list/props.mjs';
import './list/const.mjs';
import './list/list-item.mjs';
import './list/list-item-meta.mjs';
import './list/list-item-meta-props.mjs';
import './list/type.mjs';
import './progress/progress.mjs';
import './progress/constants.mjs';
import './progress/props.mjs';
import './progress/type.mjs';
import './skeleton/skeleton.mjs';
import './skeleton/props.mjs';
import './skeleton/type.mjs';
import './swiper/swiper.mjs';
import './swiper/props.mjs';
import './swiper/swiper-item.mjs';
import './swiper/type.mjs';
import './table/base-table.mjs';
import './table/base-table-props.mjs';
import './table/hooks/useTableHeader.mjs';
import './table/hooks/useMultiHeader.mjs';
import './table/hooks/useClassName.mjs';
import './table/ellipsis.mjs';
import './table/hooks/useColumnResize.mjs';
import './_common/js/table/set-column-width-by-drag.mjs';
import './_common/js/table/utils.mjs';
import './_common/js/table/recalculate-column-width.mjs';
import './table/hooks/useFixed.mjs';
import './_common/js/utils/getScrollbarWidth.mjs';
import './table/hooks/usePagination.mjs';
import './table/hooks/useAffix.mjs';
import './table/tbody.mjs';
import './table/tr.mjs';
import './table/utils.mjs';
import './table/hooks/useLazyLoad.mjs';
import './_common/js/utils/observe.mjs';
import './table/hooks/useRowspanAndColspan.mjs';
import './table/hooks/useStyle.mjs';
import './table/thead.mjs';
import './table/tfoot.mjs';
import './table/primary-table.mjs';
import './table/primary-table-props.mjs';
import './table/hooks/useColumnController.mjs';
import './table/hooks/useRowExpand.mjs';
import './table/hooks/useRowSelect.mjs';
import './table/hooks/useSorter.mjs';
import './table/sorter-button.mjs';
import './table/hooks/useFilter.mjs';
import './table/filter-controller.mjs';
import './table/hooks/useDragSort.mjs';
import 'sortablejs';
import './_common/js/utils/swapDragArrayElement.mjs';
import './table/hooks/useAsyncLoading.mjs';
import './table/editable-cell.mjs';
import './table/hooks/useEditableRow.mjs';
import './table/enhanced-table.mjs';
import './table/enhanced-table-props.mjs';
import './table/hooks/useTreeData.mjs';
import './_common/js/table/tree-store.mjs';
import './table/hooks/useTreeSelect.mjs';
import './table/type.mjs';
import './table/interface.mjs';
import './collapse/collapse.mjs';
import './collapse/props.mjs';
import './collapse/collapse-panel.mjs';
import './collapse/collapse-panel-props.mjs';
import './collapse/useCollapseAnimation.mjs';
import './collapse/type.mjs';
import './watermark/watermark.mjs';
import './watermark/props.mjs';
import './_common/js/watermark/generateBase64Url.mjs';
import './_common/js/watermark/randomMovingStyle.mjs';
import './_common/js/utils/injectStyle.mjs';
import './watermark/hooks.mjs';
import './watermark/type.mjs';
import './rate/rate.mjs';
import './rate/props.mjs';
import './rate/type.mjs';
import './alert/alert.mjs';
import './alert/props.mjs';
import './alert/type.mjs';
import './drawer/drawer.mjs';
import './drawer/props.mjs';
import './drawer/hooks.mjs';
import './drawer/type.mjs';
import './guide/guide.mjs';
import './guide/props.mjs';
import './guide/utils/index.mjs';
import './guide/utils/getScrollParent.mjs';
import './guide/utils/getRelativePosition.mjs';
import './guide/utils/getTargetElm.mjs';
import './guide/utils/scrollToElm.mjs';
import './guide/type.mjs';
import './message/type.mjs';
import './notification/notificationList.mjs';
import './notification/notification.mjs';
import './notification/props.mjs';
import './notification/animate.mjs';
import './notification/const.mjs';
import './notification/type.mjs';
import './popconfirm/popconfirm.mjs';
import './popconfirm/props.mjs';
import './popconfirm/type.mjs';
import './upload/upload.mjs';
import './upload/dragger.mjs';
import './upload/props.mjs';
import './upload/util.mjs';
import './upload/image.mjs';
import './upload/flow-list.mjs';
import './upload/single-file.mjs';
import './upload/hooks.mjs';
import './upload/useUpload.mjs';
import './_common/js/upload/xhr.mjs';
import './upload/interface.mjs';
import './upload/type.mjs';
import './config-provider/config-provider.mjs';

function install(app, config) {
  Object.keys(components).forEach(function (key) {
    /plugin/i.test(key) ? app.use(components[key]) : app.use(components[key], config);
  });
}
var index = {
  install: install,
  version: typeof "0.21.1" === "undefined" ? "" : "0.21.1"
};

export { index as default, install };
//# sourceMappingURL=index.mjs.map
